import React, { memo, useCallback } from 'react';
import Combobox from '@ls/react-combobox-grid';
import { useDispatch, useSelector } from 'react-redux';
import {
  //   selectModeValue,
  selectBenchmarkScenarioValue, selectIsDisableBenchmarkWorkspace
} from 'state/selections/selector';
import { setBenchmarkScenariosValue, setIsDisableBenchmarkWorkspace } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
// import Mode from 'state/selections/Mode';
import {
  selectFetchingScenarioOptions,
  selectScenarioOptions,
} from 'state/scenario/selector';
import ToolTip from '@ls/react-tooltip';
import Switch from '@ls/react-switch';
import styled from 'styled-components';

const StyledSwitch = styled(Switch)`
  margin: 0 0 0 10px;
  width: 9em;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  padding: 5px 3px;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.25);
  }
`;


const BenchmarkScenarioSelector = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectFetchingScenarioOptions);
  const options = useSelector(selectScenarioOptions);

  const value = useSelector(selectBenchmarkScenarioValue(SelectionState.UNCOMMITTED));
  const onChange = useCallback(
    (value) => dispatch(setBenchmarkScenariosValue(value)),
    [dispatch]
  );

  const isDisableBenchmarkWorkspace = useSelector(
    selectIsDisableBenchmarkWorkspace(SelectionState.UNCOMMITTED)
  );

  const onChangeDisableBenchmarkWorkspace = useCallback(
    (value) => { dispatch(setIsDisableBenchmarkWorkspace(value)) },
    [dispatch]
  );



  return (
    <Combobox
      placeholder="Benchmark Scenarios..."
      options={options}
      onChange={onChange}
      value={value}
      label="Benchmark Scenario: "
      loading={loading}
      variation={1}
      tooltip={`${'(Optional) '}Select Benchmark scenario to apply.`}
      disabled={isDisableBenchmarkWorkspace}
      componentR={
        <ToolTip
          label={`Disable Benchmark Workspace`}
        >
          <div>
            <StyledSwitch
              onChange={onChangeDisableBenchmarkWorkspace}
              value={isDisableBenchmarkWorkspace}
              label="Disable"
            />
          </div>
        </ToolTip>
      }

    />
  );
};

export default memo(BenchmarkScenarioSelector);
